import { ServiceHistoryRecord } from '../../shared/types';
import { OrderUtils } from '../../orders/utils/order.utils';

export type ServiceHistorySourceLabel = 'In-shop' | 'Way-web' | 'Way-app';
export type ServiceHistorySourceChipVariant = 'grey' | 'blue';

export interface ServiceHistorySourceChip {
  label: ServiceHistorySourceLabel;
  variant: ServiceHistorySourceChipVariant;
}

export function resolveServiceHistorySourceChip(
  record: Pick<ServiceHistoryRecord, 'way_pass_id' | 'source'>
): ServiceHistorySourceChip {
  if (!OrderUtils.isWayRedeemedOrder(record)) {
    return { label: 'In-shop', variant: 'grey' };
  }

  const normalized = String(record.source ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');

  if (normalized === 'way_app') {
    return { label: 'Way-app', variant: 'blue' };
  }

  return { label: 'Way-web', variant: 'blue' };
}
